import { render, staticRenderFns } from "./SimpleChatLight.vue?vue&type=template&id=5c95d526&"
import script from "./SimpleChatLight.vue?vue&type=script&lang=ts&"
export * from "./SimpleChatLight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports